export const LIST_FAVORITE_ADDRESSES = 'LIST_FAVORITE_ADDRESSES';
export const LIST_FAVORITE_ADDRESSES_LOADING = 'LIST_FAVORITE_ADDRESSES_LOADING';